<template>
	<div class="todo-statistic">
		<legend class="font-medium text-black text-lg font-medium mb-2">{{ title }}</legend>
		<div>
			<div class="flex justify-between my-1" v-for="request_type in data" :key="request_type.id">
				<p class="flex-1 text-black">{{ request_type.name }}</p>
				<div class="flex-1"></div>
				<div class="flex-1 flex justify-between">
					<div class="flex-1" v-for="detail in request_type.details" :key="detail.id">
						<span class="w-3 h-3 inline-block rounded-full box-content" :style="{ backgroundColor: getBackgroundColor(detail.id) }"></span>
						<span class="text-black">
							{{ detail.display }}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "RequestByDepartmentStatistics",
	components: {},
	props: {
		title: String,
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			statusColors: {
				2: "#EB5757",
				0: "#2B59B2",
				1: "#219653"
			}
		};
	},
	methods: {
		getBackgroundColor(id) {
			return this.statusColors[id];
		}
	}
};
</script>

<style lang="scss" scoped>
.todo-statistic {
	border: 1px solid var(--color-gray-5);
	border-radius: 8px;
	padding: 20px;

	::v-deep .apexcharts-canvas {
		left: 50%;
		transform: translateX(-50%);
	}

	::v-deep .apexcharts-legend {
		flex-direction: row;
		padding: 0;
		justify-content: space-between !important;
		align-items: center !important;

		.apexcharts-legend-series {
			// &:not(:last-child) {
			// 	// margin-bottom: 8px !important;
			// 	box-sizing: border-box;
			// 	width: 25px !important;
			// }
		}

		.apexcharts-legend-marker {
			// margin-right: 8px;
			box-sizing: content-box;
			width: 22px !important;
			// height: 25px !important;
			// border-radius: 50% !important;
		}

		.apexcharts-legend-text {
			display: flex;
			width: 100%;
			justify-content: space-between;
			font-size: 1rem !important;
		}
	}
}
</style>
